import axios from "axios";
import { baseUrlAPI } from "@/config/api";

const HOST = baseUrlAPI;

export default {
  get(payload = {}) {
    const params = payload.params || {};
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/clientes`,
        method: "get",
        params
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  getById(payload = {}) {
    const clienteId = payload.clienteId || "";

    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/clientes/${clienteId}`,
        method: "get"
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  getDirecciones(payload = {}) {
    const id = payload.clienteId || "";

    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/clientes/${id}/direcciones`,
        method: "get"
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  getStadistics(payload = {}) {
    const id = payload.clienteId || "";
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/clientes/${id}/direcciones`,
        method: "get"
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  getStadistics(payload = {}) {
    const id = payload.clienteId || "";
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/clientes/${id}/carros/estadisticas`,
        method: "get"
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  getCars(payload = {}) {
    const id = payload.clienteId || "";
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/clientes/${id}/carros`,
        method: "get"
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  getCarsItems(payload = {}) {
    const id = payload.clienteId || "";
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/clientes/${id}/carros/item-productos`,
        method: "get"
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  put(payload = {}) {
    const clienteId = payload.clienteId;
    const data = payload.data || {};
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/clientes/${clienteId}`,
        method: "put",
        data
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  post(payload = {}) {
    const data = payload.data || {};
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/clientes`,
        method: "post",
        data
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  delete(payload = {}) {
    const clienteId = payload.clienteId;
    return new Promise((resolve, reject) => {
      axios({
        url: `${HOST}/clientes/${clienteId}`,
        method: "delete"
      })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  }
};
